
import { MENU_ITEM_REMOVED } from "@/constants/MixpanelEvents.js";
import MenuDisableItemDialog from "../dialogs/menu-disable-item-dialog.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import RemoveModifyItemTile from "./remove-modify-item-tile.vue";
import MenuItemDeleteConfirmationDialog from "../dialogs/menu-item-delete-confirmation-dialog.vue";
import MenuUploadInfoDialog from "../dialogs/menu-upload-info-dialog.vue";
export default {
  components: {
    MenuDisableItemDialog,
    RemoveModifyItemTile,
    MenuItemDeleteConfirmationDialog,
    MenuUploadInfoDialog
  },
  data() {
    return {
      panel: "",
      deleteLoading: false,
      showDeleteConfirmationDialog: false,
      radioGroup: "",
      combosToBeRemoved: [],
      isItemActive: true,
      showMenuDisableItemDialog: false,
      showItemActiveWarningDialog: false
    };
  },
  props: {
    item: {}
  },
  computed: {
    ...mapState("menu", ["combosList"]),
    ...mapGetters("restaurant", ["getChannelNames"])
  },
  methods: {
    ...mapActions("menu", ["deleteMenuItem", "getSyncStatus", "getCombosList"]),
    handleMenuItemSwitchToggle() {
      if (
        this.item.item_is_active === 1 ||
        this.item.pending_availability_sync
      ) {
        this.showItemActiveWarningDialog = true;
      } else {
        this.showDeleteConfirmationDialog = true;
      }
    },
    handleDeleteMenuItem() {
      this.deleteLoading = true;
      this.deleteMenuItem(this.item.id)
        .then((response) => {
          if (response.status === 200) {
            this.mixPanelTrackEvent(MENU_ITEM_REMOVED);
            this.$nuxt.$emit("show-toast", {
              text: "Item successfully deleted",
              color: "success darken-2",
              icon: "done",
              flat: true
            });
            this.getCombosList(true);
            this.getSyncStatus();
            if (!this.$vuetify.breakpoint.mdAndUp) {
              this.$emit("close-edit-modify-dialog");
            }
          } else {
            this.isActive = !this.isActive;
            this.$nuxt.$emit("show-error-toast", response);
          }
        })
        .catch((errr) => {
          this.isActive = !this.isActive;
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.deleteLoading = false;
          this.showDeleteConfirmationDialog = false;
        });
    },
    handleCancelAction() {
      this.showDeleteConfirmationDialog = false;
    },
    handleMenuItemDisableToggle(status) {
      this.isItemActive = status;
      if (!this.isItemActive) {
        this.showMenuDisableItemDialog = true;
      }
    },
    handleDisableItemDialogClose() {
      this.isItemActive = true;
      this.showMenuDisableItemDialog = false;
    }
  }
};
